import { GoogleAuthProvider } from 'firebase/auth';
import React, { useContext, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../Context/AuthProvider/AuthProvider';
import useTitle from '../../hook/useTitle';
import toast from 'react-hot-toast'
const Login = () => {
    useTitle('Login')
    // const [spinner, setSpinner] = useState(true)
    const { login, googleSign,loading } = useContext(AuthContext);
    const [success, setSucces] = useState(false)
    const [error, setError] = useState('')
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';
    const googleProvider = new GoogleAuthProvider();
    const handleLogin = (event) => {
        if (loading) {
            return <>
                <div role="status">
                    <svg aria-hidden="true" className="mr-2 w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
                    </svg>
                    <span className="sr-only">Loading...</span>
                </div>
            </>

        }
        event.preventDefault();
        setSucces(false);
        const form = event.target;
        const email = form.email.value;
        const password = form.password.value;
        console.log(email, password);

        login(email, password)
            .then(result => {
                const user = result.user;
                console.log(user);
                setSucces(true);
                setError('');
                toast.success('Successfully login')
                // setSpinner(false)
                // jwt work start
                const currentUser = {
                    email: user.email
                }
                console.log(currentUser);
                fetch('https://assignment-11-server-sooty.vercel.app/jwt', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(currentUser)
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);
                        localStorage.setItem('my-token', data.token)
                    })
                    .catch(error => console.error(error))
                // jwt work end

                //sob success hole navigate kore ekhane jabe
                if (user.email) {
                    navigate(from, { replace: true })
                }
                form.reset()
            })
            .catch(error => setError(error.message))
    }
    const handleGoogleSignIn = () => {
        googleSign(googleProvider)
            .then(result => {
                const user = result.user;
                console.log(user);
                setSucces(true);
                if (user.email) {
                    navigate(from, { replace: true })
                }
            })
            .catch(error => setError(error.message))
    }
    return (
        <div className="hero bg-base-200">
            <div className="w-4/5 hero-content flex-col lg:flex-row-reverse">
                <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
                    <form className="card-body" onSubmit={handleLogin}>
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Email</span>
                            </label>
                            <input type="email" name='email' placeholder="email" className="input input-bordered" />
                        </div>
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Password</span>
                            </label>
                            <input type="password" name='password' placeholder="password" className="input input-bordered" />
                        </div>
                        {
                            success ? <p className='text-green-700'>Login successfully</p> : <p className='text-rose-600'>{error}</p>
                        }
                        <div className="flex flex-col w-full border-opacity-50">
                            <div className="form-control mt-6">
                                <button className="btn btn-primary">Login</button>
                            </div>
                            <div className="divider">OR</div>
                            <div className="grid card rounded-box place-items-center">
                                <button onClick={handleGoogleSignIn} className="btn btn-secondary">Sign in with Google</button>
                            </div>
                        </div>
                        <p className='text-center'>You are new. Please <Link className='underline font-bold underline-offset-1' to='/signup'>Signup</Link></p>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;